export const SUPPORTED_PLATFORMS = ['TurboWarp', 'NitroBolt'];
